import React, { useContext, useState } from 'react';
import { Context } from '../../context/news_search.context';
import { Modal } from 'react-bootstrap';
import { deleteBookmarkSearch } from '../../../services/bookmarked_searches/bookmarked_searches.service';
import { ExtendedSavedSearch } from '../../types/news_search.types';
import { GENERIC_ERROR_MESSAGE } from '../../../components/react/alert_popup/constants';

const ModalDeleteSearch: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const {
    savedSearches,
    setSavedSearches,
    showDeleteSearchModal,
    setShowDeleteSearchModal,
    searchToBeDeleted,
    setSearchToBeDeleted,
    appliedSavedSearch,
    setAppliedSavedSearch,
    setAlertData,
  } = useContext(Context);

  const onCancelClick = (): void => {
    setShowDeleteSearchModal(false);
    setSearchToBeDeleted({});
  };

  // When users confirm their intention to delete saved search via the modal, proceed to deletion
  const onSearchDeletion = (): void => {
    if (!searchToBeDeleted.id) return;
    setIsLoading(true);

    deleteBookmarkSearch(searchToBeDeleted.id)
      .then(() => {
        setAlertData({
          type: 'success',
          message: `You have successfully deleted '${searchToBeDeleted.title}'.`,
        });

        // If the saved search is currently applied, clear `appliedSavedSearch` context object
        if (appliedSavedSearch && appliedSavedSearch.id === searchToBeDeleted.id) {
          setAppliedSavedSearch({});
        }

        const updatedSavedSearches = savedSearches.filter(
          (search) => search.id !== searchToBeDeleted.id
        );

        setSavedSearches(updatedSavedSearches as ExtendedSavedSearch[]);
      })
      .catch(() => {
        setAlertData({ type: 'error', message: GENERIC_ERROR_MESSAGE, });
      })
      .finally(() => {
        setSearchToBeDeleted({});
        setShowDeleteSearchModal(false);
        setIsLoading(false);
      });
  };

  return (
    <Modal
      size={'lg'}
      show={showDeleteSearchModal}
      onHide={onCancelClick}
      animation={false}
      aria-labelledby='Delete search modal'
    >
      <Modal.Header closeButton className='ps-45 pe-4'>
        <h2 className='modal-title fs-2' data-testid='modal-search-deletion'>
          Delete alert
        </h2>
      </Modal.Header>
      <Modal.Body className='px-45 pt-35 mb-25'>
        Are you sure you&apos;d like to delete the alert for &quot;{searchToBeDeleted.title}&quot;?
      </Modal.Body>
      <Modal.Footer className='px-45'>
        <button
          className='btn btn-link link-blue-orange me-3'
          onClick={onCancelClick}
          disabled={isLoading}
        >
          Cancel
        </button>
        <button className='btn btn-outline-primary' onClick={onSearchDeletion} disabled={isLoading}>
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDeleteSearch;
